import { createFileRoute } from '@tanstack/react-router';
import { SuperAdminInspectionLibraryPage } from '@/pages/super-admin/inspection-library/SuperAdminInspectionLibraryPage';

export const Route = createFileRoute('/_authenticated/super-admin/inspection-library')({
	component: SuperAdminInspectionLibraryPage,
});
